import request from '@/utils/request'

// 新增保证金收款记录post
export const addDepositReceipt = (data) => {
  return request.post('/api/finance/deposit-receipt/add', data)
}

// 批量删除保证金收款记录post
export const batchDeleteDepositReceipt = (data) => {
  return request.post('/api/finance/deposit-receipt/batch-delete', data)
}

// 批量核实post
export const batchVerifyDepositReceipt = (data) => {
  return request.post('/api/finance/deposit-receipt/batch-verify', data)
}

// 删除保证金收款记录post
export const deleteDepositReceipt = (id) => {
  return request.post(`/api/finance/deposit-receipt/delete/${id}`)
}

// 获取保证金收款详情get
export const getDepositReceiptDetail = (id) => {
  return request.get(`/api/finance/deposit-receipt/detail/${id}`)
}

// 分页查询保证金收款记录get
export const getDepositReceiptPage = (params) => {
  return request.get('/api/finance/deposit-receipt/page',  params )
}

// 修改保证金收款记录post
export const updateDepositReceipt = (data) => {
  return request.post('/api/finance/deposit-receipt/update', data)
}

// 核实状态更新 post
export const verifyDepositReceipt = (id, data) => {
  return request.post(`/api/finance/deposit-receipt/verify/${id}`, data)
}

// 新增保证金核退记录POST
export const addDepositRefund = (data) => {
  return request.post('/api/finance/deposit-refund/add', data)
}

// 批量删除保证金核退记录POST
export const batchDeleteDepositRefund = (data) => {
  return request.post('/api/finance/deposit-refund/batch-delete', data)
}

// 批量核实POST
export const batchVerifyDepositRefund = (data) => {
  return request.post('/api/finance/deposit-refund/batch-verify', data)
}

// 删除保证金核退记录POST
export const deleteDepositRefund = (id) => {
  return request.post(`/api/finance/deposit-refund/delete/${id}`)
}

// 获取保证金核退详情 GET
export const getDepositRefundDetail = (id) => {
  return request.get(`/api/finance/deposit-refund/detail/${id}`)
}

// 分页查询保证金核退记录 GET
export const getDepositRefundPage = (params) => {
  return request.get('/api/finance/deposit-refund/page',  params )
}

// 修改保证金核退记录POST
export const updateDepositRefund = (data) => {
  return request.post('/api/finance/deposit-refund/update', data)
}

// 执行退还操作POST
export const verifyDepositRefund = (id, data) => {
  return request.post(`/api/finance/deposit-refund/verify/${id}`, data)
}
